export default __webpack_public_path__ + "static/media/besiege.231d97c9.png";